import { render, staticRenderFns } from "./AttributeChannel.vue?vue&type=template&id=28209d64&"
import script from "./AttributeChannel.vue?vue&type=script&lang=js&"
export * from "./AttributeChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports